var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:_vm.$style.wrapper},[(_vm.learningUnits && _vm.learningUnits.length)?_vm._l((_vm.learningUnits),function(learningUnitId,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":{
          name: 'learning-unit-detail',
          params: {
            learningUnitId: ("" + learningUnitId)
          }
        },"target":"_blank"}},[_vm._v(" Unit Page ")])],1)}):void 0],2)}
var staticRenderFns = []

export { render, staticRenderFns }